import { Box, Button, HStack, Text } from '@chakra-ui/react';
import { FiRotateCcw } from 'react-icons/fi'

/** Shown when a staged draft survived a navigation away (browser Back, refresh, crash).
 *  Recovery rather than blocking — the browser cannot be reliably intercepted here. */
export function DraftRecoveryBanner({ onRestore, onDiscard }: {
  onRestore: () => void
  onDiscard: () => void
}) {
  return (
    <Box bg="yellow.50" borderWidth="1px" borderColor="yellow.300" borderRadius="md" p={3} mb={3}>
      <HStack justify="space-between" gap={3} flexWrap="wrap">
        <Text fontSize="sm" color="yellow.900">
          You have unsaved schedule changes from earlier.
        </Text>
        <HStack gap={2}>
          <Button size="sm" variant="ghost" minH="44px" onClick={onDiscard}>Discard</Button>
          <Button size="sm" colorPalette="brand" minH="44px" onClick={onRestore}>
            <FiRotateCcw />Restore
          </Button>
        </HStack>
      </HStack>
    </Box>
  );
}
